<template>
  <div class="container">
      <div class="row">
        <div v-if="loading">
          <loader></loader>
        </div>
        <div v-else>
          <h1>Usuários</h1>
          <hr/>
          <router-link id="btn-add-request-type" :to="{name: 'UserImport'}" type="button" class="btn btn-primary">
            <span class="glyphicon glyphicon-plus"></span> Adicionar Usuários
          </router-link>
          <br/>
          <br/>
          <div class="col-sm-1" >
            <select class="input-sm" v-model="perPage" @change="getUsers">
              <option :value="5">5</option>
              <option :value="10">10</option>
              <option :value="15">15</option>
            </select>
          </div>
          <div class="col-sm-9"></div>
          <div class="col-sm-2">
            <b-form-input v-model="filter" @keyup.enter="getUsers" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
          </div>
          <b-table :items="users" :fields="fields" striped hover />
          <b-pagination size="sm" :total-rows="count" :per-page="perPage" v-model="currentPage" @input="getUsers" />
        </div>
      </div>
  </div>
</template>

<script>

import { Parse } from '../Global'
import Loader from './util/Loader'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      users: [],
      count: 0,
      fields: {
        username: { label: 'Login', sortable: true },
        name: { label: 'Nome', sortable: true },
        email: { label: 'E-mail', sortable: true },
        createdAtFmt: {label: 'Data de Criação', sortable: true},
        updatedAtFmt: {label: 'Última Atualização', sortable: true}
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      let self = this
      self.loading = true
      let params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter
      }
      Parse.Cloud.run('listUsers', params).then(results => {
        self.users = results.users
        self.count = results.count
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UserList.vue?0235ee0a